import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import analytics from "web/script/analytics/analytics";
import browser from "web/script/utils/browser";
import withReduxProvider from "web/react/redux-provider";
import { openEmailCaptureOverlay } from "web/redux/ducks/email-capture-overlay";

function DesignerExitTrigger({ lystId, openEmailCaptureOverlay, designerName, popupEnabled }) {
    useEffect(() => {
        // Trigger should be enabled only on desktop
        if (browser.getViewport() !== browser.VIEWPORTS.DESKTOP) {
            return;
        }

        document.addEventListener("mouseleave", onBodyMouseLeave);
        return () => {
            document.removeEventListener("mouseleave", onBodyMouseLeave);
        };
    });

    function onBodyMouseLeave(event) {
        if (event.clientX > 150 || event.clientY > 50) {
            return;
        }
        // Remove mouseleave event listener so if the user closes the popup, we don't
        // show it again untill they go on another page or refresh the page.
        document.removeEventListener("mouseleave", onBodyMouseLeave);

        analytics.event("du_popup", "move_cursor", "viewport", true);

        if (popupEnabled === true) {
            const emailCaptureOptions = {
                captureType: "du_popup",
                designerId: lystId,
                designerName: designerName,
            };
            openEmailCaptureOverlay(emailCaptureOptions);
        }
    }
    return null;
}

export default withReduxProvider(connect(null, { openEmailCaptureOverlay })(DesignerExitTrigger));

DesignerExitTrigger.propTypes = {
    designerName: PropTypes.string,
    lystId: PropTypes.number,
    openEmailCaptureOverlay: PropTypes.func.isRequired,
    popupEnabled: PropTypes.any,
};
